<template>
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none"  xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4H2v16h12v-2H4v-6h16V8H4V6h16V4zm0 0h2v8h-2V4zm2 14h-2v-2h2v-2h-2v2h-2v-2h-2v2h2v2h-2v2h2v-2h2v2h2v-2z" fill="currentColor"/>
  </svg>
</template>
